module.exports = __webpack_public_path__ + "img/menu-white.9868da46.svg";